document.addEventListener("DOMContentLoaded", function () {
    const tocList = document.getElementById("toc-list");
    const headings = document.querySelectorAll("h2.blog_toc, .blog_toc h2");
    const headings_2 = document.querySelectorAll(".blog_toc h2");

    // Create TOC
    headings.forEach((heading, index) => {
        if (heading.textContent != "") {
            if (!heading.id) {
                heading.id = `blog-heading-${index}`;
            }

            const li = document.createElement("li");
            const a = document.createElement("a");
            a.href = `#${heading.id}`;
            a.classList.add("link");
            a.textContent = heading.textContent;
            li.appendChild(a);
            tocList.appendChild(li);
        }
    });

    // Toggle for TOC
    const toggleButton = document.querySelector(".blog_toc-toggle");
    const tocContainer = document.getElementById("table-of-contents");
    const tocIcon = toggleButton.querySelector(".blog_toc-icon");

    toggleButton.addEventListener("click", function () {
        const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
        toggleButton.setAttribute("aria-expanded", !isExpanded);
        tocList.classList.toggle("hidden");
        tocIcon.classList.toggle("rotated");
    });
});